import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import config from "./config";
import buildVersion from "./buildVersion.json";

window.APP_VERSION = buildVersion.version;

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      loginWith: {
        username: true,
      },
      signUpVerificationMethod: "code",
      userAttributes: {
        email: {
          required: true,
        },
      },
      allowGuestAccess: true,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
      cookieStorage: {
        domain:
          process.env.NODE_ENV === "production"
            ? ".vicuscapital.com"
            : "localhost",
        path: "/",
        expires: 1,
        sameSite: process.env.NODE_ENV === "production" ? "strict" : "lax",
        secure: process.env.NODE_ENV === "production" ? true : false,
      },
    },
  },
  Storage: {
    S3: {
      bucket: config.s3.BUCKET,
      region: config.s3.REGION,
    },
  },
  API: {
    REST: {
      "core-api": {
        endpoint: config.apiUserGateway.URL,
        region: config.cognito.REGION,
      },
      "compliance-api": {
        endpoint: config.apiComplianceGateway.URL,
        region: config.cognito.REGION,
      },
    },
  },
});
cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
